import React from "react";
import { IconButton, Grid, useTheme, styled, Button } from "@mui/material";
import { Menu, Create, Reply, ReplyAll, Forward, Delete, Cached } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { getInvertColor } from "utils/themeUtils";

type Props = {
	setAlertOpen: (boolean) => void;
	mailToShow;
};

const HeadBar: React.FC<Props> = ({ setAlertOpen, mailToShow }) => {
	const theme = useTheme();

	return (
		<>
			<Grid item style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
				<IconButton onClick={() => setAlertOpen(true)} size="large">
					<Menu style={{ color: getInvertColor(theme.palette.primary.main) }} />
				</IconButton>
				<NavButton
					startIcon={<Create />}
					variant="contained"
					style={{ backgroundColor: "#FE484E", marginLeft: 10, color: "#fff", fontWeight: "bold" }}
					onClick={() => setAlertOpen(true)}
					disableElevation
				>
					{/* <Typography style={{ color: "#fff" }}> */}
					<FormattedMessage id="EMAIL.top_nav.create_message.button" />
					{/* </Typography> */}
				</NavButton>
			</Grid>
			{!!mailToShow && (
				<Grid item style={{ marginLeft: 20, display: "flex", flexDirection: "row", alignItems: "center" }}>
					<NavButton startIcon={<Reply />} variant="text" onClick={() => setAlertOpen(true)}>
						<FormattedMessage id="EMAIL.top_nav.reply.button" />
					</NavButton>
					<NavButton startIcon={<ReplyAll />} variant="text" onClick={() => setAlertOpen(true)}>
						<FormattedMessage id="EMAIL.top_nav.reply_all.button" />
					</NavButton>
					<NavButton startIcon={<Forward />} variant="text" onClick={() => setAlertOpen(true)}>
						<FormattedMessage id="EMAIL.top_nav.forward.button" />
					</NavButton>
					<NavButton startIcon={<Delete />} variant="text" onClick={() => setAlertOpen(true)}>
						<FormattedMessage id="EMAIL.top_nav.trash.button" />
					</NavButton>
					<NavButton startIcon={<Cached />} variant="text" onClick={() => setAlertOpen(true)}>
						<FormattedMessage id="EMAIL.top_nav.refresh.button" />
					</NavButton>
				</Grid>
			)}
		</>
	);
};

export default HeadBar;

const NavButton = styled(Button)(({ theme }) => ({
	textTransform: "none",
	color: getInvertColor(theme.palette.primary.main),
	fontSize: "0.75rem",
	fontWeight: 600,
}));
